(() => {
  "use strict";

  const API =
    "https://miightyverse-membership-engine-v2.miightyali.workers.dev";

  const KEY = "mv_rewards_admin_session_v1";

  const $ = (id) => document.getElementById(id);

  const esc = (value) =>
    String(value ?? "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");

  const fmt = (value) =>
    new Intl.NumberFormat("en-US").format(
      Number(value || 0)
    );

  const when = (value) => {
    if (!value) {
      return "";
    }

    const date = new Date(value);

    if (Number.isNaN(date.getTime())) {
      return String(value);
    }

    return new Intl.DateTimeFormat("en-US", {
      month: "short",
      day: "numeric",
      year: "numeric",
      hour: "numeric",
      minute: "2-digit"
    }).format(date);
  };

  const fulfillmentStatuses = [
    ["approved", "Approved"],
    ["scheduled", "Scheduled"],
    ["preparing", "Preparing"],
    ["ready_for_pickup", "Ready for Pickup"],
    ["shipped", "Shipped"],
    ["fulfilled", "Fulfilled"],
    ["completed", "Completed"]
  ];

  let session = {
    staffId: "",
    secret: ""
  };

  let queue = [];
  let selected = null;

  function note(message) {
    const notice = $("mv-ra-notice");

    notice.textContent = message;
    notice.classList.add("show");

    clearTimeout(note.timer);

    note.timer = setTimeout(() => {
      notice.classList.remove("show");
    }, 3200);
  }

  function headers() {
    return {
      "Content-Type": "application/json",
      "X-MiightyVerse-Staff-ID": session.staffId,
      "X-MiightyVerse-Staff-Secret": session.secret
    };
  }

  async function api(path, options = {}) {
    const response = await fetch(API + path, {
      ...options,
      headers: {
        ...headers(),
        ...(options.headers || {})
      }
    });

    const text = await response.text();

    let data;

    try {
      data = text
        ? JSON.parse(text)
        : {};
    } catch {
      throw new Error("Invalid Worker response.");
    }

    if (
      !response.ok ||
      data.success === false
    ) {
      throw new Error(
        data.error ||
        "Request failed."
      );
    }

    return data;
  }

  function renderStats(stats = {}) {
    [
      "pending",
      "approved",
      "active",
      "completed",
      "rejected"
    ].forEach((key) => {
      const element = $(`mv-ra-${key}`);

      if (element) {
        element.textContent = fmt(
          stats[key]
        );
      }
    });
  }

  function rewardCard(item) {
    const pendingActions =
      item.status === "pending"
        ? `
          <button
            class="mv-ra-button approve"
            data-approve="${esc(item.redemptionUuid)}"
          >
            Approve
          </button>

          <button
            class="mv-ra-button reject"
            data-reject="${esc(item.redemptionUuid)}"
          >
            Reject
          </button>
        `
        : "";

    const noteBadge =
      item.fulfillmentNotes
        ? "<span>📝 Note saved</span>"
        : "";

    return `
      <article class="mv-ra-card">
        <div>
          <span
            class="mv-ra-status ${esc(item.status)}"
          >
            ${esc(item.statusLabel)}
          </span>

          <h3 class="mv-ra-card-title">
            ${esc(item.rewardEmoji)}
            ${esc(item.rewardName)}
          </h3>

          <div class="mv-ra-meta">
            <b>${esc(item.memberName)}</b>
            <span>${esc(item.memberId)}</span>
            <span>${esc(item.membership)}</span>
            <b>${fmt(item.pointsReserved)} points</b>
            <span>${esc(when(item.requestedAt))}</span>
            ${noteBadge}
          </div>
        </div>

        <div class="mv-ra-actions">
          <button
            class="mv-ra-button"
            data-view="${esc(item.redemptionUuid)}"
          >
            View / Notes
          </button>

          ${pendingActions}
        </div>
      </article>
    `;
  }

  function renderQueue() {
    const list = $("mv-ra-list");

    list.innerHTML = queue.length
      ? queue.map(rewardCard).join("")
      : `
        <div class="mv-ra-empty">
          No reward requests match this view.
        </div>
      `;

    list
      .querySelectorAll("[data-view]")
      .forEach((button) => {
        button.onclick = () => {
          openReward(
            button.dataset.view,
            "view"
          );
        };
      });

    list
      .querySelectorAll("[data-approve]")
      .forEach((button) => {
        button.onclick = () => {
          openReward(
            button.dataset.approve,
            "approve"
          );
        };
      });

    list
      .querySelectorAll("[data-reject]")
      .forEach((button) => {
        button.onclick = () => {
          openReward(
            button.dataset.reject,
            "reject"
          );
        };
      });
  }

  async function loadQueue() {
    const params = new URLSearchParams({
      status: $("mv-ra-status").value
    });

    const search =
      $("mv-ra-search").value.trim();

    if (search) {
      params.set("search", search);
    }

    const data = await api(
      `/admin/rewards/queue?${params.toString()}`
    );

    queue = data.items || [];

    renderStats(
      data.stats || {}
    );

    $("mv-ra-user").textContent =
      data.staff?.displayName ||
      "Rewards Admin";

    renderQueue();
  }

  async function login(event) {
    event.preventDefault();

    session = {
      staffId:
        $("mv-ra-staff-id").value.trim(),
      secret:
        $("mv-ra-secret").value.trim()
    };

    if (
      !session.staffId ||
      !session.secret
    ) {
      note(
        "Enter your staff ID and portal secret."
      );
      return;
    }

    try {
      await loadQueue();

      localStorage.setItem(
        KEY,
        JSON.stringify(session)
      );

      $("mv-ra-login").classList.add(
        "mv-ra-hidden"
      );

      $("mv-ra-app").classList.remove(
        "mv-ra-hidden"
      );
    } catch (error) {
      note(error.message);
    }
  }

  function fulfillmentControl(item) {
    const status = String(
      item.status || ""
    ).toLowerCase();

    if (
      status === "pending" ||
      status === "declined" ||
      status === "cancelled"
    ) {
      return "";
    }

    const options = fulfillmentStatuses
      .map(([value, label]) => `
        <option
          value="${esc(value)}"
          ${value === status ? "selected" : ""}
        >
          ${esc(label)}
        </option>
      `)
      .join("");

    return `
      <div class="mv-ra-fulfillment-control">
        <small>Fulfillment status</small>
        <select
          id="mv-ra-fulfillment-status"
          class="mv-ra-select"
        >
          ${options}
        </select>
      </div>
    `;
  }

  function fulfillmentDetails(item) {
    const method = item.fulfillmentMethod || "";

    return `
      <div class="mv-ra-fulfillment-fields">
        <label for="mv-ra-method">Fulfillment method</label>
        <select id="mv-ra-method" class="mv-ra-select">
          <option value="">Choose method</option>
          <option value="shipping" ${method === "shipping" ? "selected" : ""}>Shipping</option>
          <option value="pickup" ${method === "pickup" ? "selected" : ""}>Pickup</option>
          <option value="digital" ${method === "digital" ? "selected" : ""}>Digital delivery</option>
          <option value="scheduled" ${method === "scheduled" ? "selected" : ""}>Scheduled experience</option>
        </select>

        <div id="mv-ra-shipping-fields">
          <label for="mv-ra-carrier">Carrier</label>
          <input id="mv-ra-carrier" class="mv-ra-input" value="${esc(item.carrier || "")}" placeholder="USPS, UPS, FedEx, DHL">

          <label for="mv-ra-tracking-number">Tracking number</label>
          <input id="mv-ra-tracking-number" class="mv-ra-input" value="${esc(item.trackingNumber || "")}" placeholder="Enter tracking number">

          <label for="mv-ra-tracking-url">Tracking link</label>
          <input id="mv-ra-tracking-url" class="mv-ra-input" value="${esc(item.trackingUrl || "")}" placeholder="https://...">

          <label for="mv-ra-arrival">Estimated arrival</label>
          <input id="mv-ra-arrival" class="mv-ra-input" type="date" value="${esc(item.estimatedArrival || "")}">
        </div>

        <div id="mv-ra-pickup-fields">
          <label for="mv-ra-pickup-location">Pickup location</label>
          <input id="mv-ra-pickup-location" class="mv-ra-input" value="${esc(item.pickupLocation || "")}" placeholder="Location or event">

          <label for="mv-ra-pickup-instructions">Pickup instructions</label>
          <textarea id="mv-ra-pickup-instructions" class="mv-ra-textarea" rows="3" placeholder="What the member needs to know">${esc(item.pickupInstructions || "")}</textarea>
        </div>

        <label for="mv-ra-member-update">Member-visible update</label>
        <textarea id="mv-ra-member-update" class="mv-ra-textarea" rows="3" placeholder="Example: Your signed CD is being prepared.">${esc(item.memberUpdate || "")}</textarea>
      </div>
    `;
  }

  function toggleFulfillmentFields() {
    const method = $("mv-ra-method")?.value || "";
    const shipping = $("mv-ra-shipping-fields");
    const pickup = $("mv-ra-pickup-fields");

    if (shipping) {
      shipping.style.display =
        method === "shipping" ? "grid" : "none";
    }

    if (pickup) {
      pickup.style.display =
        method === "pickup" ? "grid" : "none";
    }
  }

  function openReward(
    redemptionUuid,
    mode
  ) {
    selected = queue.find(
      (item) =>
        item.redemptionUuid ===
        redemptionUuid
    );

    if (!selected) {
      note(
        "The reward request could not be opened."
      );
      return;
    }

    $("mv-ra-modal-title").textContent =
      mode === "approve"
        ? "Approve Reward"
        : mode === "reject"
          ? "Reject Reward"
          : "Reward Request & Notes";

    $("mv-ra-detail").innerHTML = `
      <div>
        <small>Member</small>
        <b>${esc(selected.memberName)}</b>
        <br>
        ${esc(selected.memberId)}
      </div>

      <div>
        <small>Reward</small>
        <b>
          ${esc(selected.rewardEmoji)}
          ${esc(selected.rewardName)}
        </b>
      </div>

      <div>
        <small>Points</small>
        <b>${fmt(selected.pointsReserved)}</b>
      </div>

      <div>
        <small>Status</small>
        <b>
          ${esc(
            selected.statusLabel ||
            selected.status
          )}
        </b>
      </div>

      ${mode === "view"
        ? fulfillmentControl(selected) + fulfillmentDetails(selected)
        : ""}
    `;

    if (mode === "view") {
      const methodSelect = $("mv-ra-method");
      if (methodSelect) {
        methodSelect.onchange = toggleFulfillmentFields;
      }
      toggleFulfillmentFields();
    }

    $("mv-ra-notes-label").textContent =
      mode === "reject"
        ? "Rejection reason (required)"
        : "Admin notes — staff only";

    $("mv-ra-notes").value =
      selected.fulfillmentNotes || "";

    const confirmButton =
      $("mv-ra-confirm");

    confirmButton.dataset.mode = mode;

    confirmButton.textContent =
      mode === "approve"
        ? "Approve Reward"
        : mode === "reject"
          ? "Reject & Return Points"
          : (
              selected.status === "pending"
                ? "Save Note"
                : "Save Status & Note"
            );

    $("mv-ra-modal").classList.add(
      "open"
    );
  }

  function closeModal() {
    $("mv-ra-modal").classList.remove(
      "open"
    );
    selected = null;
  }

  async function confirmRewardAction() {
    const mode = this.dataset.mode;

    const notes =
      $("mv-ra-notes").value.trim();

    if (!selected) {
      note(
        "No reward request selected."
      );
      return;
    }

    if (
      mode === "reject" &&
      !notes
    ) {
      note(
        "Enter a rejection reason."
      );
      return;
    }

    this.disabled = true;

    try {
      let endpoint = "";
      let payload = {};
      let successMessage = "";

      if (mode === "approve") {
        endpoint =
          "/admin/rewards/approve";

        payload = {
          redemptionUuid:
            selected.redemptionUuid,
          notes
        };

        successMessage =
          "Reward approved.";
      } else if (mode === "reject") {
        endpoint =
          "/admin/rewards/reject";

        payload = {
          redemptionUuid:
            selected.redemptionUuid,
          reason: notes
        };

        successMessage =
          "Reward rejected and points returned.";
      } else {
        const statusSelect =
          $("mv-ra-fulfillment-status");

        if (statusSelect) {
          endpoint =
            "/admin/rewards/status";

          payload = {
            redemptionUuid:
              selected.redemptionUuid,
            status:
              statusSelect.value,
            notes,
            fulfillmentMethod:
              $("mv-ra-method")?.value || "",
            carrier:
              $("mv-ra-carrier")?.value.trim() || "",
            trackingNumber:
              $("mv-ra-tracking-number")?.value.trim() || "",
            trackingUrl:
              $("mv-ra-tracking-url")?.value.trim() || "",
            estimatedArrival:
              $("mv-ra-arrival")?.value || "",
            pickupLocation:
              $("mv-ra-pickup-location")?.value.trim() || "",
            pickupInstructions:
              $("mv-ra-pickup-instructions")?.value.trim() || "",
            memberUpdate:
              $("mv-ra-member-update")?.value.trim() || ""
          };

          successMessage =
            "Fulfillment status and note saved.";
        } else {
          endpoint =
            "/admin/rewards/note";

          payload = {
            redemptionUuid:
              selected.redemptionUuid,
            notes
          };

          successMessage = notes
            ? "Admin note saved."
            : "Admin note cleared.";
        }
      }

      await api(endpoint, {
        method: "POST",
        body: JSON.stringify(payload)
      });

      note(successMessage);

      closeModal();

      await loadQueue();
    } catch (error) {
      console.error(
        "Reward admin action failed:",
        error
      );

      note(
        error instanceof Error
          ? error.message
          : "Unable to update the reward."
      );
    } finally {
      this.disabled = false;
    }
  }

  function restoreSession() {
    try {
      const saved = JSON.parse(
        localStorage.getItem(KEY) ||
        "{}"
      );

      if (
        saved.staffId &&
        saved.secret
      ) {
        session = saved;

        $("mv-ra-staff-id").value =
          session.staffId;

        $("mv-ra-secret").value =
          session.secret;

        loadQueue()
          .then(() => {
            $("mv-ra-login").classList.add(
              "mv-ra-hidden"
            );

            $("mv-ra-app").classList.remove(
              "mv-ra-hidden"
            );
          })
          .catch(() => {
            localStorage.removeItem(KEY);

            note(
              "Saved staff access expired. Sign in again."
            );
          });
      }
    } catch {
      localStorage.removeItem(KEY);
    }
  }

  document.addEventListener(
    "DOMContentLoaded",
    () => {
      $("mv-ra-login-form").onsubmit =
        login;

      $("mv-ra-refresh").onclick =
        () => {
          loadQueue().catch((error) => {
            note(error.message);
          });
        };

      $("mv-ra-logout").onclick =
        () => {
          localStorage.removeItem(KEY);
          location.reload();
        };

      $("mv-ra-status").onchange =
        () => {
          loadQueue().catch((error) => {
            note(error.message);
          });
        };

      $("mv-ra-search-button").onclick =
        () => {
          loadQueue().catch((error) => {
            note(error.message);
          });
        };

      $("mv-ra-search").onkeydown =
        (event) => {
          if (event.key === "Enter") {
            loadQueue().catch((error) => {
              note(error.message);
            });
          }
        };

      $("mv-ra-modal-close").onclick =
        closeModal;

      $("mv-ra-confirm").onclick =
        confirmRewardAction;

      $("mv-ra-modal").onclick =
        (event) => {
          if (
            event.target ===
            $("mv-ra-modal")
          ) {
            closeModal();
          }
        };

      restoreSession();
    }
  );
})();
